import { render, staticRenderFns } from "./ReferredPacking.vue?vue&type=template&id=5c4a6bde&"
import script from "./ReferredPacking.vue?vue&type=script&lang=js&"
export * from "./ReferredPacking.vue?vue&type=script&lang=js&"
import style0 from "./ReferredPacking.vue?vue&type=style&index=0&id=5c4a6bde&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports